import * as React from 'react';
import { CheckCircle } from '@phosphor-icons/react';
import { Avatar, AvatarImage, AvatarFallback } from '../../../ui/avatar';
import { cn } from '../../../../lib/utils';
import { TruncatedText } from '../../TruncatedText';

interface CreatorCellProps {
  name: string;
  handle: string;
  avatarUrl?: string;
  verified?: boolean;
  className?: string;
}

export function CreatorCell({ name, handle, avatarUrl, verified, className }: CreatorCellProps): React.ReactElement {
  const initials = name
    .split(' ')
    .map((w) => w[0] ?? '')
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <Avatar size="default">
        {avatarUrl && <AvatarImage src={avatarUrl} alt="" />}
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
      <div className="flex min-w-0 flex-col">
        <div className="flex items-center gap-1">
          <TruncatedText text={name} className="text-body-sm-semibold text-foreground" />
          {verified && (
            <CheckCircle
              weight="fill"
              size={14}
              className="shrink-0 text-blue-500"
              aria-label="verified"
            />
          )}
        </div>
        <span className="text-caption-regular text-muted-foreground">@{handle}</span>
      </div>
    </div>
  );
}
